import React, { useState, useEffect, useRef } from "react";
import axios from "../../services/axios";
import { useNavigate, useLocation } from "react-router";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import usePremiumTrial from "../../hooks/usePremiumTrial";
import useAuth from "../../hooks/useAuth";

import { convertLanguageToField } from "../../utils/functions";

import Header, {
  NoHeaderScroll,
  BackHeaderLeft,
} from "../../components/navigation/header";
import HotLevelIcon from "../../components/desafiosPicantes/hotLevelIcon";
import FlippableCard from "../../components/flippableCard";
import Timer from "../../components/timer";
import Feedback from "../../components/solo/feedback";
import NoChallengesModal from "../../components/modal/noChallenges";

export default function SoloGame() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { category, playerIndex } = useLocation().state;
  const { player1, player2 } = useSelector((state) => state.players);
  const title = convertLanguageToField(i18n.language, "title");
  const desafio = convertLanguageToField(i18n.language, "desafio");

  const [currentChallenge, setCurrentChallenge] = useState({});
  const [playedChallenges, setPlayedChallenges] = useState([]);
  const [flipped, setFlipped] = useState(true);
  const [endedModal, setEndedModal] = useState(false);
  const [sequence, setSequence] = useState(category.sequencia ? 1 : 0);
  const { spendTrialCredit } = usePremiumTrial();
  const { user } = useAuth();

  const player = playerIndex === 1 ? player1 : player2;
  const cardRef = useRef();

  useEffect(() => {
    const resizeCard = () => {
      if (cardRef.current) {
        const size = cardRef.current.getBoundingClientRect();
        let targetW = (size.height * 3) / 4;

        if (targetW - 40 > window.innerWidth - 100) {
          targetW = window.innerWidth - 40;
        }

        cardRef.current.style.width = `${targetW}px`;
      }
    };

    resizeCard();
    window.addEventListener("resize", resizeCard);

    return () => {
      window.removeEventListener("resize", resizeCard);
    };
  }, []);

  const getChallenge = () => {
    let allowed = true;
    if (!user?.isPremium) {
      // allowed = spendTrialCredit("solo");
      allowed = true;
    }

    if (!allowed) {
      return;
    }

    setFlipped(true);

    let id = category.id_cat_solo;

    if (category?.custom) {
      id = `|${category.id_categorias_solo_usuario}|`;
    }

    axios
      .post("/solo/getChallenge", {
        category: id,
        player: player.gender,
        orientation: player.orientationCalc,
        exclude: playedChallenges,
        sequence: sequence,
        id_usuario: user?.id_usuario,
      })
      .then((response) => {
        if (Array.isArray(response?.data) && response?.data?.length) {
          const result = response.data[0];
          setCurrentChallenge(result);
          let id = result.id_solo;
          if (result?.custom) {
            id = `|${result.id_desafio_solo}|`;
          }
          setPlayedChallenges([...playedChallenges, id]);
          setTimeout(() => {
            setFlipped(false);
          }, 500);

          if (category.sequencia) {
            setSequence(sequence + 1);
          }
        } else {
          setEndedModal(true);
        }
      });
  };

  const handleCategories = () => {
    navigate("/solo/categories", { state: { player: playerIndex } });
  };

  const handleRestart = () => {
    window.location.reload();
  };

  const handleNext = () => {
    getChallenge();
  };

  const HeaderCenter = () => {
    return (
      <div className="flex w-[150px]">
        {[1, 2, 3, 4, 5].map((i) => {
          return (
            <HotLevelIcon
              key={i}
              size={20}
              active={currentChallenge?.hot_level >= i}
              className="pe-1"
              inactiveColor="#9D2791"
            />
          );
        })}
      </div>
    );
  };

  const Back = () => {
    return (
      <div className="flex flex-col h-full justify-center items-center object-contain">
        <img
          className="w-1/3"
          src={require("../../assets/images/games/solo/icone.png")}
          alt="back1"
        />
        <img
          className="w-2/3"
          src={require("../../assets/images/games/solo/logo-us.png")}
          alt="back2"
        />
      </div>
    );
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={BackHeaderLeft} HeaderCenter={HeaderCenter} />
      <NoHeaderScroll className="ps-5 pe-5 no-scroll">
        <div className="flex flex-col h-full">
          <div className="flex flex-col items-center mb-5">
            <h2 className="text-xl font-semibold">{category[title]}</h2>
          </div>
          <div className="flex-1 flex justify-center h-1">
            <FlippableCard
              ref={cardRef}
              className={`h-full w-full transition-all duration-500 cursor-default`}
              frontClassName={"!rounded-3xl !bg-[#BD2CAE] !p-3"}
              backClassName={"!rounded-3xl !bg-[#721F69] !p-3"}
              borda={require("../../assets/images/games/solo/borda.png")}
              borda_back={require("../../assets/images/games/solo/borda.png")}
              borderSize={42}
              Back={Back}
              style={
                flipped
                  ? {
                      transform: "rotateY(180deg)",
                    }
                  : {
                      // transform: "rotateY(180deg)",
                    }
              }
            >
              <div className="scroll h-[calc(100%-4rem)] mt-8 mb-8 ms-3 me-3 ">
                <div
                  className={`transition-opacity duration-200 ${
                    flipped ? "opacity-0" : "opacity-100 delay-200"
                  }`}
                >
                  <p className="font-semibold text-base">
                    {currentChallenge?.custom
                      ? currentChallenge.desafio
                      : currentChallenge[desafio]}
                  </p>
                </div>
              </div>
            </FlippableCard>
            <div
              className="relative hidden"
              style={{
                "transform-style": "preserve-3d",
              }}
            >
              <div className="h-[calc(100%-4rem)]">
                <div
                  className="h-full w-full relative bg-red-300 scroll"
                  style={{ "backface-visibility": "hidden" }}
                >
                  <p className="font-semibold text-base">
                    {currentChallenge?.custom
                      ? currentChallenge.desafio
                      : currentChallenge[desafio]}
                  </p>
                </div>
              </div>
              <div
                className="h-full w-full bg-blue-300 absolute top-0 left-0"
                style={{
                  "backface-visibility": "hidden",
                  transform: "rotateY(180deg)",
                }}
              ></div>
            </div>
          </div>
          <div className="mt-5">
            {!currentChallenge?.custom ? (
              <Feedback
                id={currentChallenge?.id_solo}
                likes={currentChallenge?.like}
                deslikes={currentChallenge?.dislike}
              />
            ) : (
              <div className="h-11"></div>
            )}
          </div>
          {currentChallenge?.duracao ? (
            <div className="flex justify-center">
              <Timer
                timer={currentChallenge?.duracao}
                color="#9D2791"
                onTimeEnd={() => {
                  getChallenge();
                }}
              />
            </div>
          ) : null}
          <div className="mb-5 mt-5">
            <button
              type="button"
              onClick={handleNext}
              className="btn btn-solo w-full"
            >
              {t("next")}
            </button>
          </div>
        </div>
      </NoHeaderScroll>
      <NoChallengesModal
        title={t("noChallenges")}
        text1={t("dialogText1HotChallenges")}
        text2={t("dialogText2HotChallenges")}
        visible={endedModal}
        handleGoBack={handleCategories}
        handleRestart={handleRestart}
      />
    </div>
  );
}
